import React from "react";

const moderationAreas = [
  {
    title: "Issues",
    description:
      "Plan permanent deletion workflows so moderators can fully remove outdated or inappropriate topics when necessary.",
    checklist: [
      "Bulk review dashboard",
      "Permanent delete with audit trail",
      "Author notifications",
    ],
  },
  {
    title: "Solutions",
    description:
      "Enforce community guidelines around solution quality. Coming work includes direct removal and quality flags.",
    checklist: [
      "Escalation triggers",
      "Permanent removal",
      "Auto-notify contributors",
    ],
  },
  {
    title: "Action Groups",
    description:
      "Coordinate how inactive groups are retired. Soft delete exists today; full removal controls will surface here.",
    checklist: [
      "Membership notifications",
      "Archive before delete",
      "Admin-only irreversible delete",
    ],
  },
];

export function ContentModerationSection() {
  return (
    <section className="flex flex-col gap-6">
      <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <h2 className="text-xl font-semibold text-gray-900">Content Moderation Roadmap</h2>
        <p className="mt-3 text-sm text-gray-600">
          The items below map out the moderation capabilities that will land in this panel. Use
          them as a checklist while we progressively build permanent deletion and escalation
          tooling.
        </p>
      </div>
      <div className="grid gap-5 lg:grid-cols-3">
        {moderationAreas.map((area) => (
          <article
            key={area.title}
            className="flex flex-col gap-4 rounded-lg border border-dashed border-gray-300 bg-gray-50 p-5"
          >
            <h3 className="text-lg font-semibold text-gray-900">{area.title}</h3>
            <p className="text-sm text-gray-600">{area.description}</p>
            <ul className="space-y-1 text-sm text-gray-500">
              {area.checklist.map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <span className="mt-1 h-2 w-2 rounded-full bg-gray-400" aria-hidden />
                  <span>{item} (stub)</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}
